import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import icons from 'react-icons';
import styles from './Icon.module.css';
import { IconProps } from './types';
const brandIconColors: Partial<Record<keyof typeof icons, string>> = {
  facebook: '#1877F2',
  instagram: '#E1306C',
  linkedin: '#0077B5'
};
function Icon(t0) {
  const $ = _c(26);
  let color;
  let name;
  let props;
  let style;
  let t1;
  let t2;
  let title;
  let userClassName;
  if ($[0] !== t0) {
    ({
      size: t1,
      color,
      title,
      name,
      className: userClassName,
      style,
      minTargetSizeInRem: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = color;
    $[2] = name;
    $[3] = props;
    $[4] = style;
    $[5] = t1;
    $[6] = t2;
    $[7] = title;
    $[8] = userClassName;
  } else {
    color = $[1];
    name = $[2];
    props = $[3];
    style = $[4];
    t1 = $[5];
    t2 = $[6];
    title = $[7];
    userClassName = $[8];
  }
  const size = t1 === undefined ? "300" : t1;
  const minTargetSizeInRem = t2 === undefined ? 0 : t2;
  const ChosenIcon = icons[name] ?? null;
  if (!ChosenIcon) {
    throw new Error(`Icon ${name} does not exist`);
  }
  const colorVar = color && `var(--betterplace-color-${color})` || brandIconColors[name];
  let t3;
  if ($[9] !== colorVar) {
    t3 = {
      fill: colorVar
    };
    $[9] = colorVar;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const colorProps = t3;
  const t4 = !title;
  let t5;
  if ($[11] !== userClassName) {
    t5 = classNames(styles.icon, userClassName);
    $[11] = userClassName;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = `var(--betterplace-sizing-${size})`;
  const t7 = `var(--betterplace-sizing-${size})`;
  const t8 = `calc((${minTargetSizeInRem}rem - var(--betterplace-sizing-${size})) / 2)`;
  let t9;
  if ($[13] !== colorProps || $[14] !== style || $[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = {
      width: t6,
      height: t7,
      padding: t8,
      boxSizing: "content-box",
      ...colorProps,
      ...style
    };
    $[13] = colorProps;
    $[14] = style;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = t9 as React.CSSProperties;
  let t11;
  if ($[19] !== ChosenIcon || $[20] !== props || $[21] !== t10 || $[22] !== t4 || $[23] !== t5 || $[24] !== title) {
    t11 = <ChosenIcon {...props} aria-label={title} aria-hidden={t4} className={t5} style={t10} />;
    $[19] = ChosenIcon;
    $[20] = props;
    $[21] = t10;
    $[22] = t4;
    $[23] = t5;
    $[24] = title;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}
export default Icon;